import { render, staticRenderFns } from "./TempSupplier.vue?vue&type=template&id=5d85d14d&scoped=true"
import script from "./TempSupplier.vue?vue&type=script&lang=js"
export * from "./TempSupplier.vue?vue&type=script&lang=js"
import style0 from "./TempSupplier.vue?vue&type=style&index=0&id=5d85d14d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85d14d",
  null
  
)

export default component.exports